export function slugify(value) {
  return String(value || '').normalize('NFKC').trim().toLowerCase()
    .replace(/[\s_]+/g, '-').replace(/[^\p{L}\p{N}-]/gu, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
}
export function parseBookingLocation(location = window.location) {
  let path;
  try { path = decodeURIComponent(location.pathname); }
  catch { throw new Error('This property URL is not valid.'); }
  const segments = path.split('/').filter(Boolean);
  if (segments.length > 1 || segments.some(s => !/^[\p{L}\p{N}][\p{L}\p{N}\s_-]{0,119}$/u.test(s))) {
    throw new Error('This property URL is not valid.');
  }
  const [hashPath, hashQuery = ''] = location.hash.replace(/^#/, '').split('?');
  const query = new URLSearchParams(hashQuery);
  new URLSearchParams(location.search).forEach((value, key) => query.set(key, value));
  const legacyScreen = ['booking', 'member'].includes(segments[0]) ? segments[0] : null;
  const screen = hashPath === '/booking' ? 'booking' : hashPath === '/member' ? 'member' : legacyScreen || 'index';
  // Preserve the real code: underscores and hyphens can identify different shops.
  return { slug: legacyScreen ? '' : slugify(segments[0]), shopCode: legacyScreen ? '' : segments[0] || '', query, screen };
}
export function bookingScreenUrl(page, location = window.location) {
  const { query } = parseBookingLocation(location);
  const search = query.toString();
  const path = /^\/(booking|member)\/?$/.test(location.pathname) ? '/' : location.pathname;
  return `${path}${search ? `?${search}` : ''}${['booking', 'member'].includes(page) ? `#/${page}` : ''}`;
}
export function safeClientUrl(value) {
  if (!value) return null;
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
  } catch { return null; }
}
